import { render, staticRenderFns } from "./TestMethod.vue?vue&type=template&id=55e17110&"
import script from "./TestMethod.vue?vue&type=script&lang=js&"
export * from "./TestMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports